import { Dialog, Toast, ImageUploader } from "antd-mobile";
import axios from "axios";
import React, { useState, useContext, useEffect } from "react";
import {
  Button,
  Card,
  Col,
  Modal,
  Row,
  FormLabel,
  FormControl,
} from "react-bootstrap";
import { Link, Navigate, useNavigate } from "react-router-dom";
import $ from "jquery";
import PsContext from "../../context";
import {
  groupByMultiple,
  momentDate,
  semesterValue,
  sleep,
  jsonToQuery,
  getFileLiveUrl,
} from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import Header from "../header";
import { Image, List } from "antd-mobile";
import { FileTextOutlined } from "@ant-design/icons";
import { CommentOutlined, CustomerServiceOutlined } from "@ant-design/icons";
import { FloatButton, Switch, message,Form,Input,Spin } from "antd";
import ModuleAccess from "../../context/moduleAccess";
import FileBrowserModal from "../../app/fileManager";
import ReactFileReader from "react-file-reader";
import { SELECT_USER_PHOTO } from "../../utils/data";

const AddService = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [feedbackForm] = Form.useForm();
  useEffect(() => {
  }, []);
  const onFinishAddServiceRequest = (values) => {
   
    var form=new FormData();
    form.append('student_uuid',context.user.uuid);
    form.append('request_type',props.requestType.id);
    form.append('description',values.service_request.description);
    setLoader(true);
    axios
      .post(ServiceUrl.REQUEST.ADD_REQUEST, form)
      .then((res) => {
        if (res["data"].status == "1") {
          Toast.show({ content: res["data"].message || "Saved" });
          props.onSuccess();
          setLoader(false);
        } else {
          Toast.show({ content: res["data"].message || "Error" });
          setLoader(false);
        }
      }); 
  };
  return (
    <>
      <div>
        <Card>
          <Card.Header onClick={(e) => props.onHide()}></Card.Header>
          <Card.Body>
            <Spin spinning={loader}>
            <Form
              name="basic"
              form={feedbackForm}
              labelAlign="left"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              initialValues={{ remember: true }}
              onFinish={onFinishAddServiceRequest}
              autoComplete="off"
            >
              <Row>
                <Col md={12}>
                  <Form.Item
                    //label="Type"
                  //name={['adjustments', 'narration']}
                  //rules={[{ required: true, message: 'Please Enter Narration' }]}
                  >
                    New Request : <span style={{color:'blue'}}>{props.requestType.request_type_name}</span>
                  </Form.Item>
                </Col>
                <Col md={12}>
                  <Form.Item
                    label="Description"
                    name={['service_request', 'description']}
                    rules={[{ required: true, message: 'Please Enter Description' }]}
                  >
                    <Input.TextArea />
                  </Form.Item>
                </Col>
                <Col md={12} className="text-end mt-3">
                  <Button
                    type="submit"
                    variant="success"
                    className="btn btn-block"
                  >
                    Save
                  </Button>
                </Col>
              </Row>
            </Form>
            </Spin>
          </Card.Body>
        </Card>
      </div>
    </>
  );
};
export default AddService;
